import { useCallback, useEffect, useState } from "react";

export const useGetBlogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchBlogs = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/blogs`
      );
      if (!response.ok) {
        throw new Error(`Failed to fetch blogs: ${response.status}`);
      }

      const data = await response.json();
      setBlogs(data?.blogs?.blogs ?? []);
    } catch (err) {
      console.error("useGetBlogs error", err);
      setError(err.message || "Failed to load blogs");
      setBlogs([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBlogs();
  }, [fetchBlogs]);

  return { blogs, loading, error, refetch: fetchBlogs };
};

export const useGetBlogById = (id) => {
  const [blog, setBlog] = useState({});
  const [topBlogs, setTopBlogs] = useState([]);
  const [loading, setLoading] = useState(Boolean(id));
  const [error, setError] = useState(null);

  const fetchBlog = useCallback(
    async (blogId = id) => {
      if (!blogId) {
        setBlog({});
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/blogs/${blogId}`
        );
        if (!response.ok) {
          throw new Error(`Failed to fetch blog: ${response.status}`);
        }

        const data = await response.json();
        setBlog(data?.blog ?? {});
        setTopBlogs(data?.topBlogs ?? []);
      } catch (err) {
        console.error("useGetBlogById error", err);
        setError(err.message || "Failed to load blog");
        setBlog({});
      } finally {
        setLoading(false);
      }
    },
    [id]
  );

  useEffect(() => {
    fetchBlog();
  }, [fetchBlog]);

  return { blog, loading, error, refetch: fetchBlog , topBlogs};
};
